import Skeleton from "@mui/material/Skeleton";

const RenderLoading = () => {
  return (
    <div className="w-full h-2/3">
      <div className="flex flex-col h-full">
        <div className="w-full flex justify-between items-center py-3">
          <Skeleton width="20%" />
          <Skeleton width="10%" />
          <Skeleton width="40%" />
        </div>
        <div className="w-full flex justify-start items-center p-2">
          <Skeleton width="10%" className="mr-2" />
          <Skeleton width="10%" className="mr-2" />
          <Skeleton width="15%" className="mr-2" />
          <Skeleton width="10%" className="mr-2" />
          <Skeleton width="15%" className="mr-2" />
        </div>
        <Skeleton width="100%" height="100%" />
        <div className="flex justify-between w-full">
          <Skeleton width="30%" />
          <Skeleton width="20%" />
        </div>
      </div>
    </div>
  );
};

export default RenderLoading;
